"use client";

import { useQuery } from "@tanstack/react-query";

import { useUser } from "@/contexts/user-provider";

import { PERMISSIONS, hasPermission } from "@/lib/permissions";

import { AnalyticsDashboard } from "@/types/analytics";

import { listDashboards } from "@/api/analytics/analytics";

const EMPTY: AnalyticsDashboard[] = [];

/**
 * The tenant's saved (non built-in) dashboards. The analytics sidebar and the
 * analytics directory both list them, so they share one cached query.
 */
export function useAnalyticsCustomDashboards(enabled = true) {
  const { currentUser } = useUser();
  const canRead = hasPermission(currentUser, PERMISSIONS.ANALYTICS_READ);

  const { data, isLoading } = useQuery({
    queryKey: ["analytics", "dashboards", "list"],
    queryFn: () => listDashboards(),
    enabled: enabled && canRead,
    select: (page) =>
      (page?.data ?? []).map((dashboard) => ({
        ...dashboard,
        type: "database" as const,
      })),
  });

  return { dashboards: data ?? EMPTY, isLoading };
}
